import { Type } from "@sinclair/typebox";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { surveyDataSchema } from "../../legacy/index.js";
import { api } from "../../lib/api.js";
export const surveyDataResponseSchema = Type.Object({
    success: Type.Boolean(),
});
export const persistSurveyDataSchema = Type.Partial(Type.Pick(surveyDataSchema, [
    "freemiumTrainingStyle",
    "freemiumExperienceLevel",
    "freemiumTrainerGender",
    "freemiumPrimaryGoal",
    "freemiumDaysOfWeek",
    "preCopilotEquipment",
    "height",
    "age",
    "weight",
    "biologicalSex",
    "freemiumPlanId",
    "weightSystem",
]));
export const updateSurveyData = ({ userId, data, }) => {
    return api
        .patch(`clients/${userId}/persistSurveyData`, {
        json: data,
    })
        .json();
};
export const useUpdateSurveyData = ({ mutationConfig, } = {}) => {
    const queryClient = useQueryClient();
    const { onSuccess, ...restConfig } = mutationConfig || {};
    return useMutation({
        mutationFn: updateSurveyData,
        onSuccess: (data, ...args) => {
            void queryClient.invalidateQueries({
                queryKey: ["clients"],
            });
            console.log(data);
            onSuccess?.(data, ...args);
        },
        onError: (error) => {
            console.error(error);
        },
        ...restConfig,
    });
};
//# sourceMappingURL=updateSurveyData.js.map